import React from 'react';
import { ScreenSize } from 'glints-aries';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import OnboardingFooter from 'src/components/Footer/OnboardingFooter';
import { MetadataRenderer } from 'src/components/MetaDescription/MetadataRenderer';
import { Background, TitleWrapper } from 'src/styles/pages/onboarding/global';
import { SignUpWrapper } from 'src/styles/pages/onboarding/signupWithEmail';

import { Title } from './SignUpPage.sc';

const SignUpForm = dynamic(() => import('./SignUpFormPsychFlat'));

const SignUpWrapperExtend = styled(SignUpWrapper)`
  max-width: 360px;
  margin-bottom: 2em;

  @media (min-width: ${ScreenSize.tablet}px) {
    max-width: 800px;
  }
`;

const SignUpEmail: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = () => (
  <Background>
    <MetadataRenderer title="Sign Up" glintsTrackingName="signup_email" />
    <TitleWrapper>
      <FormattedMessage
        id="create.glints.profile"
        defaultMessage="Let's create your {break}{glints} profile."
        values={{
          break: <br />,
          glints: 'Glints',
        }}
        tagName={Title}
      />
    </TitleWrapper>
    <SignUpWrapperExtend>
      <SignUpForm />
    </SignUpWrapperExtend>

    <OnboardingFooter />
  </Background>
);

export default SignUpEmail;
